// 当页面初始没有容器的时候，点击页面提示框添加主容器操作
export const ADD_CONTAINER_MAINBOX = 'ADD_CONTAINER_MAINBOX'

// 当页面初始没有底部容器的时候，点击页面提示框添加底部容器操作
export const ADD_CONTAINER_FOOTERBOX = 'ADD_CONTAINER_FOOTERBOX'

// 当页面初始没有头部容器的时候，点击页面提示框添加头部容器操作
export const ADD_CONTAINER_CUSTOM = 'ADD_CONTAINER_CUSTOM'

// 对主容器操作，添加栅格
export const ADD_CONTAINER_COL = 'ADD_CONTAINER_COL'

// 对头部容器操作，添加栅格
export const ADD_CONTAINER_CUSTOMCOL = 'ADD_CONTAINER_CUSTOMCOL'

// 需要固定的主容器组件索引数组传入iframe中，而后置为空
// export const GET_PUBLISH_PAGE_DATA_STRONGE = 'GET_PUBLISH_PAGE_DATA_STRONGE'

// 点击容器组件更多按钮显示操作按钮
export const SHOW_CONTAINER_BOX_OPT = 'SHOW_CONTAINER_BOX_OPT'

// 点击栅格更多按钮显示操作按钮
export const SHOW_CONTAINER_COL_OPT = 'SHOW_CONTAINER_COL_OPT'

// 选择需要添加容器组件以及显示组件
export const CHOOSE_SHOW_CONTAINER_COMPONENT_DATA = 'CHOOSE_SHOW_CONTAINER_COMPONENT_DATA'

// 选择需要添加容器组件以及显示组件
export const CHOOSE_SHOW_CONTAINER_COMPONENT_CUSTOM_DATA = 'CHOOSE_SHOW_CONTAINER_COMPONENT_CUSTOM_DATA'

// 获取主容器是否 nohover
export const GET_CONTAINER_MAINBOX_NOHOVER = 'GET_CONTAINER_MAINBOX_NOHOVER'

// 获取栅格是否 nohover
export const GET_CONTAINER_COL_NOHOVER = 'GET_CONTAINER_COL_NOHOVER'

// 获取容器是否 nohover
export const GET_CONTAINER_BOX_NOHOVER = 'GET_CONTAINER_BOX_NOHOVER'

// 组件异常，请求后台更新展示组件状态
export const UPDATE_COMPONENT_STATUS_1 = 'UPDATE_COMPONENT_STATUS_1'

// 获取当前站点配置的数据
export const GET_SITE_CONFIG_DATA = 'GET_SITE_CONFIG_DATA'

// 点击导航栏中的菜单进行编辑页面跳转
export const DESIGN_PAGE_GOTO_WITH_HREF = 'DESIGN_PAGE_GOTO_WITH_HREF'

// 对表单容器操作，添加栅格
export const ADD_CONTAINER_FORM_COL = 'ADD_CONTAINER_FORM_COL'

// 选择需要添加表单容器组件以及显示表单展示组件
export const CHOOSE_SHOW_CONTAINER_COMPONENT_FORM_DATA = 'CHOOSE_SHOW_CONTAINER_COMPONENT_FORM_DATA'

// =========================================== 快捷键按下后调用的方法 =========================================================

// 组合按键按下动作 alt+1
export const COMBINATION_KEYS_ALT_AND_1 = 'COMBINATION_KEYS_ALT_AND_1'

// 组合按键按下动作 alt+b
export const COMBINATION_KEYS_ALT_AND_B = 'COMBINATION_KEYS_ALT_AND_B'

// 在编辑区域按下 F5 刷新
export const COMBINATION_KEYS_F5 = 'COMBINATION_KEYS_F5'

// ------------------------------------------------ 改造新、老交替线 ------------------------------------------------

// =========================================== 组件进行编辑 =========================================================

// /api/udin/component 组件加载完成后回调父级 vue 的方法 后面的 ComponentName 替换组件名称
export const API_UDIN_COMPONENT_ONLOAD_ = 'API_UDIN_COMPONENT_ONLOAD_[ComponentName]'

// /api/udin/component 选择组件后回调的方法
export const API_UDIN_COMPONENT_ONLOAD_CALLBACK_ = 'API_UDIN_COMPONENT_ONLOAD_CALLBACK_[ComponentName]'

// =========================================== 模块进行编辑 =========================================================

// /api/udin/module/official.html 模块加载完成后回调父级 vue 的方法
export const API_UDIN_MODULES_ONLOAD = 'API_UDIN_MODULES_ONLOAD'

// /api/udin/module/official.html 选择模块后回调的方法
export const API_UDIN_MODULES_ONLOAD_CALLBACK = 'API_UDIN_MODULES_ONLOAD_CALLBACK'

// ======================================= 点击页面容器部分弹窗编辑 =======================================
// 对主容器的配置进行编辑
export const EDIT_CONTAINER_MAINBOX = 'EDIT_CONTAINER_MAINBOX'
// 对底部容器的配置进行编辑
export const EDIT_CONTAINER_FOOTERBOX = 'EDIT_CONTAINER_FOOTERBOX'
// 点击空组件容器编辑
export const EDIT_EMPTY_CONTAINER_BOX = 'EDIT_EMPTY_CONTAINER_BOX'
// 编辑有内容的容器
export const EDIT_CONTAINER_BOX = 'EDIT_CONTAINER_BOX'
// 对栅格的配置进行编辑
export const EDIT_CONTAINER_COL = 'EDIT_CONTAINER_COL'
// 对头部容器的配置进行编辑
export const EDIT_CONTAINER_CONTAINERCUSTOM = 'EDIT_CONTAINER_CONTAINERCUSTOM'
// 点击头部空组件容器编辑
export const EDIT_EMPTY_CONTAINER_CUSTOMBOX = 'EDIT_EMPTY_CONTAINER_CUSTOMBOX'
// 对头部区域行格操作，行格编辑
export const EDIT_CONTAINER_CUSTOMCOL = 'EDIT_CONTAINER_CUSTOMCOL'
// 对头部区域容器操作，容器编辑
export const EDIT_CONTAINER_CUSTOMBOX = 'EDIT_CONTAINER_CUSTOMBOX'

// ======================================= 点击页面组件部分弹窗编辑 =======================================
// 编辑 button 组件
export const EDIT_COMPONENT_WITH_COMPONENTBUTTON = 'EDIT_COMPONENT_WITH_COMPONENTBUTTON'
// 编辑 articles 文章列表组件
export const EDIT_COMPONENT_WITH_COMPONENTARTICLES = 'EDIT_COMPONENT_WITH_COMPONENTARTICLES'
// 编辑 divider 分隔线组件
export const EDIT_COMPONENT_WITH_COMPONENTDIVIDER = 'EDIT_COMPONENT_WITH_COMPONENTDIVIDER'
// 编辑 image 图片组件
export const EDIT_COMPONENT_WITH_COMPONENTIMAGE = 'EDIT_COMPONENT_WITH_COMPONENTIMAGE'
// 编辑 images 图片集组件
export const EDIT_COMPONENT_WITH_COMPONENTIMAGES = 'EDIT_COMPONENT_WITH_COMPONENTIMAGES'
// 编辑 product 单个产品组件
export const EDIT_COMPONENT_WITH_COMPONENTPRODUCT = 'EDIT_COMPONENT_WITH_COMPONENTPRODUCT'
// 编辑 products 产品列表组件
export const EDIT_COMPONENT_WITH_COMPONENTPRODUCTS = 'EDIT_COMPONENT_WITH_COMPONENTPRODUCTS'
// 编辑 Richtext 富文本组件
export const EDIT_COMPONENT_WITH_COMPONENTRICHTEXT = 'EDIT_COMPONENT_WITH_COMPONENTRICHTEXT'
// 编辑 slide 幻灯片组件
export const EDIT_COMPONENT_WITH_COMPONENTSLIDE = 'EDIT_COMPONENT_WITH_COMPONENTSLIDE'
// 编辑 text 文本组件
export const EDIT_COMPONENT_WITH_COMPONENTTEXT = 'EDIT_COMPONENT_WITH_COMPONENTTEXT'
// 编辑 title 标题组件
export const EDIT_COMPONENT_WITH_COMPONENTTITLE = 'EDIT_COMPONENT_WITH_COMPONENTTITLE'
// 编辑 empty 空格组件
export const EDIT_COMPONENT_WITH_COMPONENTEMPTY = 'EDIT_COMPONENT_WITH_COMPONENTEMPTY'
// 编辑 lantern 走马灯组件
export const EDIT_COMPONENT_WITH_COMPONENTLANTERN = 'EDIT_COMPONENT_WITH_COMPONENTLANTERN'
// 编辑 baidumap 百度地图组件
export const EDIT_COMPONENT_WITH_COMPONENTBAIDUMAP = 'EDIT_COMPONENT_WITH_COMPONENTBAIDUMAP'
// 编辑 googlemap 谷歌地图组件
export const EDIT_COMPONENT_WITH_COMPONENTGOOGLEMAP = 'EDIT_COMPONENT_WITH_COMPONENTGOOGLEMAP'
// 编辑 videolink 视频链接组件
export const EDIT_COMPONENT_WITH_COMPONENTVIDEOLINK = 'EDIT_COMPONENT_WITH_COMPONENTVIDEOLINK'
// 编辑 socialicons 社交链接组件
export const EDIT_COMPONENT_WITH_COMPONENTSOCIALICONS = 'EDIT_COMPONENT_WITH_COMPONENTSOCIALICONS'
// 编辑 timeaxis 时间轴组件
export const EDIT_COMPONENT_WITH_COMPONENTTIMEAXIS = 'EDIT_COMPONENT_WITH_COMPONENTTIMEAXIS'
// 编辑 accordion 手风琴组件
export const EDIT_COMPONENT_WITH_COMPONENTACCORDION = 'EDIT_COMPONENT_WITH_COMPONENTACCORDION'
// 编辑 fixed 漂浮组件
export const EDIT_COMPONENT_WITH_COMPONENTFIXED = 'EDIT_COMPONENT_WITH_COMPONENTFIXED'
// 编辑 file 文件下载组件
export const EDIT_COMPONENT_WITH_COMPONENTFILE = 'EDIT_COMPONENT_WITH_COMPONENTFILE'
// 编辑 video 文件下载组件
export const EDIT_COMPONENT_WITH_COMPONENTVIDEO = 'EDIT_COMPONENT_WITH_COMPONENTVIDEO'
// 编辑 MenuFootfixed 移动端底部菜单组件
export const EDIT_COMPONENT_WITH_COMPONENTMENUFOOTFIXED = 'EDIT_COMPONENT_WITH_COMPONENTMENUFOOTFIXED'
// 编辑 search 组件
export const EDIT_COMPONENT_WITH_COMPONENTSEARCH = 'EDIT_COMPONENT_WITH_COMPONENTSEARCH'
// 编辑 menuH 横向菜单组件
export const EDIT_COMPONENT_WITH_COMPONENTMENUH = 'EDIT_COMPONENT_WITH_COMPONENTMENUH'
// 编辑 menuV 纵向菜单组件
export const EDIT_COMPONENT_WITH_COMPONENTMENUV = 'EDIT_COMPONENT_WITH_COMPONENTMENUV'
// 编辑 numcount 计数器组件
export const EDIT_COMPONENT_WITH_COMPONENTNUMCOUNT = 'EDIT_COMPONENT_WITH_COMPONENTNUMCOUNT'
// 编辑 sceneflip 3D图文翻转组件
export const EDIT_COMPONENT_WITH_COMPONENTSCENEFLIP = 'EDIT_COMPONENT_WITH_COMPONENTSCENEFLIP'
// 编辑 ring3d 3D相册画廊组件
export const EDIT_COMPONENT_WITH_COMPONENTRING3D = 'EDIT_COMPONENT_WITH_COMPONENTRING3D'
// 编辑 image3d 3D图文立体组件
export const EDIT_COMPONENT_WITH_COMPONENTIMAGE3D = 'EDIT_COMPONENT_WITH_COMPONENTIMAGE3D'

// ======================================= 点击页面表单容器部分弹窗编辑 =======================================
// 点击空组件容器编辑
export const EDIT_EMPTY_CONTAINER_FORM_BOX = 'EDIT_EMPTY_CONTAINER_FORM_BOX'
// 点击表单容器组件编辑
export const EDIT_CONTAINER_FORM_BOX = 'EDIT_CONTAINER_FORM_BOX'
// 对表单栅格的配置进行编辑
export const EDIT_CONTAINER_FORM_COL = 'EDIT_CONTAINER_FORM_COL'
// 对表单容器的配置进行编辑
export const EDIT_CONTAINER_FORMMAINBOX = 'EDIT_CONTAINER_FORMMAINBOX'

// ======================================= 点击页面表单组件部分弹窗编辑 =======================================
// 点击表单文本框组件
export const EDIT_COMPONENT_WITH_COMPONENTFORMTEXT = 'EDIT_COMPONENT_WITH_COMPONENTFORMTEXT'
// 点击表单多行文本框组件
export const EDIT_COMPONENT_WITH_COMPONENTFORMTEXTAREA = 'EDIT_COMPONENT_WITH_COMPONENTFORMTEXTAREA'
// 点击表单单选框框组件
export const EDIT_COMPONENT_WITH_COMPONENTFORMRADIOBOX = 'EDIT_COMPONENT_WITH_COMPONENTFORMRADIOBOX'
// 点击表单多选框框组件
export const EDIT_COMPONENT_WITH_COMPONENTFORMCHECKBOX = 'EDIT_COMPONENT_WITH_COMPONENTFORMCHECKBOX'
// 点击表单下拉框组件
export const EDIT_COMPONENT_WITH_COMPONENTFORMSELECT = 'EDIT_COMPONENT_WITH_COMPONENTFORMSELECT'
// 点击表单下拉框组件
export const EDIT_COMPONENT_WITH_COMPONENTFORMCALENDAR = 'EDIT_COMPONENT_WITH_COMPONENTFORMCALENDAR'

// ======================================= 点击页面元素弹窗编辑 =======================================
// 点击页面中的 logo ，弹出编辑 logo 弹窗
export const EDIT_LOGO = 'EDIT_LOGO'
// 点击页面中的 banner ，弹出编辑 banner 弹窗
export const EDIT_BANNER = 'EDIT_BANNER'
// 点击页面中的 navigation ，弹出编辑 navigation 弹窗
export const EDIT_NAVIGATION = 'EDIT_NAVIGATION'

// ==================================== 获取信息数据，以及其他方法 ====================================
// 使用 crypto 加密
export const CRYPTO_EN = 'CRYPTO_EN'
// 使用 crypto 解密
export const CRYPTO_DE = 'CRYPTO_DE'
// 获取当前 vue 设计区域当中显示设备是pc、手机、还是其他
export const GET_INFO_DESIGN_DEVICE = 'GET_INFO_DESIGN_DEVICE'
// 空图片的地址
export const REPERTORY_IMAGE_EMPTY = 'REPERTORY_IMAGE_EMPTY'
// 请求获取 Design 路径path
export const GET_VUE_DESIGNFUNCTIONS_GETDESIGNPATH = 'GET_VUE_DESIGNFUNCTIONS_GETDESIGNPATH'
// 错误消息提示 iframeMessageError
export const IFRAME_MESSAGE_ERROR = 'IFRAME_MESSAGE_ERROR'
// 消息提示框 iframeConfirm
export const IFRAME_CONFIRM = 'IFRAME_CONFIRM'
// 对文章系统配置进行编辑
export const EDIT_ARTICLE_SYSTEM_CONFIG = 'EDIT_ARTICLE_SYSTEM_CONFIG'
// 对产品系统配置进行编辑
export const EDIT_PRODUCT_SYSTEM_CONFIG = 'EDIT_PRODUCT_SYSTEM_CONFIG'
// 对FAQ系统配置进行编辑
export const EDIT_FAQ_SYSTEM_CONFIG = 'EDIT_FAQ_SYSTEM_CONFIG'
// 对下载系统配置进行编辑
export const EDIT_DOWNLOAD_SYSTEM_CONFIG = 'EDIT_DOWNLOAD_SYSTEM_CONFIG'
// 对信息系统配置进行编辑
export const EDIT_INFORMATION_SYSTEM_CONFIG = 'EDIT_INFORMATION_SYSTEM_CONFIG'
// 对产品表格系统配置进行编辑
export const EDIT_PDTABLE_SYSTEM_CONFIG = 'EDIT_PDTABLE_SYSTEM_CONFIG'
// 获取资源图片链接的方法
export const REPERTORY_IMAGE_SRC = 'REPERTORY_IMAGE_SRC'
// 获取资源图片链接的方法
export const REPERTORY_IMAGE_SRC_HREPERTORY = 'REPERTORY_IMAGE_SRC_HREPERTORY'
// 获取资源视频链接的方法
export const REPERTORY_VIDEO_SRC_HREPERTORY = 'REPERTORY_VIDEO_SRC_HREPERTORY'
// 渲染结束，结束 loading, 同时将当前页面的pageId回调至此 iframeLoadingOver
export const IFRAME_LOADING_OVER = 'IFRAME_LOADING_OVER'
// 点击添加自定义的首页页面
export const ADD_CUSTOM_HOME_PAGE = 'ADD_CUSTOM_HOME_PAGE'
// 更改编辑当前的站点
export const CHANGE_CURRENT_DESIGN_SITE = 'CHANGE_CURRENT_DESIGN_SITE'
// 是否有页面的数据可以进行编辑操作
export const IS_PAGE_DATA_DESING = 'IS_PAGE_DATA_DESING'
// 拿到外部链接图片对于的系统内的资源数据
export const GET_EXTERNAL_LINKS_REPERTORIES = 'GET_EXTERNAL_LINKS_REPERTORIES'
// 对产品系统列表进行刷新
export const REFRESH_PRODUCT_TABLELIST = 'REFRESH_PRODUCT_TABLELIST'
// 对文章系统列表进行刷新
export const REFRESH_ARTICLE_TABLELIST = 'REFRESH_ARTICLE_TABLELIST'
// 对Faq系统列表进行刷新
export const REFRESH_FAQ_TABLELIST = 'REFRESH_FAQ_TABLELIST'
// 对信息系统列表进行刷新
export const REFRESH_INFORMATION_TABLELIST = 'REFRESH_INFORMATION_TABLELIST'
// 对产品表格系统列表进行刷新
export const REFRESH_PDTABLE_TABLELIST = 'REFRESH_PDTABLE_TABLELIST'

// ==================================== 链接跳转动作 ====================================
// 跳转到后台，页面管理
export const GOTO_URL_BACKEND_USER_PAGES = 'GOTO_URL_BACKEND_USER_PAGES'



// WEBPACK FOOTER //
// ./src/config/windowtype.js